"use client";
import { useContext } from "react";
import { HolidayQuoteBrandContext } from "./holiday-quote-brand-context";


export function useHolidayQuoteBrand() {
  const context = useContext(HolidayQuoteBrandContext);
  if (context === undefined) {
    throw new Error(
      "useHolidayQuoteBrand must be used within a HolidayQuoteBrandProvider"
    );
  }
  return context;
}
